import React from 'react';
import { useNavigate } from 'react-router-dom';
import menus from "../../MenusLaterais";
import { MenuLateral } from "../../MenusLaterais";

import {
    Drawer,
    ListItemText,
    List,
    Divider,
    ListItem,
    ListItemIcon,
    IconButton,
    Theme,
    useTheme,
    Typography,
    Box,
    LinearProgress,
    ListItemButton,
    useMediaQuery
} from "@mui/material";

import MenuIcon from '@mui/icons-material/Menu';
import StorageIcon from '@mui/icons-material/Storage';
import { styled } from "@mui/system";
import { IEspacoUsado } from "../../../types/dashboard";
import PlanoClienteCard from "../../PlanoCliente/PlanoClienteCard";

interface Props {
    window?: () => Window;
    espacoUsadoState: [IEspacoUsado | null, React.Dispatch<React.SetStateAction<IEspacoUsado | null>>];
    menuSelecionadoState: [JSX.Element | null, React.Dispatch<React.SetStateAction<JSX.Element | null>>];
    menuAbertoState: [boolean, React.Dispatch<React.SetStateAction<boolean>>]; 
    tituloAtivoState: [string, React.Dispatch<React.SetStateAction<string>>];
}

const drawerWidth = 240;

const BFDrawer = (props: Props) => {
    const { window: windowProp } = props;

    const [menuAberto, setMenuAberto] = props.menuAbertoState;
    const [tituloAtivo] = props.tituloAtivoState;
    const [espacoUsado] = props.espacoUsadoState;

    const navigate = useNavigate();
    const theme: Theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    const handleDrawerToggle = () => {
        setMenuAberto(!menuAberto);
    };

    const cliqueMenu = (menu: MenuLateral) => {
        return () => {
            navigate(menu.rota);
            if (!isDesktop) {
                setMenuAberto(false);
            }
        };
    }

    const container = windowProp !== undefined ? () => windowProp().document.body : undefined;

    const DrawerHeader = styled('div')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        justifyContent: 'flex-end',
    }));

    const TituloEspacoUsado = styled(Typography)({
        fontSize: '0.75em'
    });

    return (<Drawer
        sx={{
            width: isDesktop && menuAberto ? drawerWidth : 0,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
                width: drawerWidth,
                border: "none",
                boxSizing: 'border-box',
                backgroundColor: theme.palette.background.paper,
                borderRight: `1px solid ${theme.palette.divider}`
            },
            border: "none"
        }}
        container={container}
        variant={isDesktop ? "persistent" : "temporary"}
        anchor="left"
        open={menuAberto}
        onClose={() => setMenuAberto(false)}
    >
        <DrawerHeader
            sx={{
                height: "56px",
                color: theme.palette.text.primary,
                border: "none",
                alignItems: "left",
                justifyContent: "left",
                backgroundColor: theme.palette.background.paper,
                borderBottom: `1px solid ${theme.palette.divider}`
            }}>

            <IconButton sx={{
                alignItems: "left",
                justifyContent: "left",
                color: "inherit"
            }}
                onClick={handleDrawerToggle}>
                <MenuIcon />
            </IconButton>
        </DrawerHeader>
        <List sx={{ px: 1 }}>
            {menus.map((menu, index) => {
                const selecionado = tituloAtivo === menu.titulo;
                return (
                    <ListItemButton 
                        key={index}
                        onClick={cliqueMenu(menu)}
                        selected={selecionado}
                        sx={{
                            my: 0.5,
                            borderRadius: '8px',
                            px: 2,
                            py: 1,
                            '&.Mui-selected': {
                                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(42, 81, 247, 0.15)' : 'rgba(42, 81, 247, 0.08)',
                                color: theme.palette.primary.main,
                                '&:hover': {
                                    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(42, 81, 247, 0.2)' : 'rgba(42, 81, 247, 0.12)',
                                },
                                '& .MuiListItemIcon-root': {
                                    color: theme.palette.primary.main,
                                }
                            },
                            '&:hover': {
                                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.04)',
                            }
                        }}
                    >
                        <ListItemIcon sx={{ 
                            color: selecionado ? theme.palette.primary.main : theme.palette.text.secondary,
                            minWidth: 36
                        }}>
                            {menu.icone}
                        </ListItemIcon>
                        <ListItemText 
                            primary={menu.titulo} 
                            primaryTypographyProps={{ 
                                fontWeight: selecionado ? 700 : 500,
                                fontSize: '0.875rem'
                            }} 
                        />
                    </ListItemButton>
                );
            })}
        </List>

        <Divider />
        <List sx={{ px: 1 }}>
            <ListItem>
                <ListItemIcon sx={{ minWidth: 36 }}>
                    <StorageIcon />
                </ListItemIcon>
                <ListItemText primary={"Armazenamento"} primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: 500 }} />
            </ListItem>
        </List>
        <Box sx={{ margin: "0px 16px", mb: 2 }}>
            <LinearProgress variant="determinate" value={(espacoUsado ? espacoUsado?.espacoUtilizado : 1) /
                (espacoUsado ? espacoUsado?.espacoTotal : 1) * 100} />
            <TituloEspacoUsado sx={{ width: "100%", textAlign: "center", margin: "8px 0px" }}>
                {`${espacoUsado?.espacoUtilizado} GB de ${espacoUsado?.espacoTotal} GB usados`}
            </TituloEspacoUsado>
        </Box>
        <PlanoClienteCard variant="drawer" />

        {/* Versão do Portal */}
        <Box sx={{ mt: 'auto', p: 2, textAlign: 'center' }}>
            <Typography variant="caption" sx={{ color: 'text.disabled', fontSize: '0.7rem', opacity: 0.6 }}>
                Portal v2.0.0
            </Typography>
        </Box>
    </Drawer >)
}

export default BFDrawer;